<template>
  <div>
    <a :href="linkDestId" v-on:click="toggleNav">
      {{ linkTitle }}
    </a>
  </div>
</template>

<script>
  
export default {
  name: 'HeaderLink',
  
  props: {
    linkTitle: String,
    linkDest: HTMLDivElement
  },
  
  data() {
    return {
      linkHash: this.linkDest
    }
  },
  
  computed: {
    linkDestId() {
      return '#' + this.linkDest.id;
    }
  },
  
  methods: {
    toggleNav() {
      if (this.$store.state.nav.isOpen) {
        this.$store.commit('toggleNav');
      } return;
    }
  }
}

</script>

<style scoped>
  div {
    border: solid yellow 0px;
    margin: 15px;
  } 
  
  a {
    color: var(--nav-link);
    transition: 300ms ease-out;
    font-size: 16px;
    font-family: Futura,Trebuchet MS,Arial,sans-serif; 
    text-decoration: none;
  }
  
  a:hover {
    color: var(--nav-link-hover);
  }
</style>
